import { template as template_1aa6f657b4b1439db4b6cd3dd423eaa7 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import pluralize from 'pluralize';
import type { PrivateDependencyViolation } from '@cardstack/host/services/realm';
interface Signature {
    Element: HTMLLIElement;
    Args: {
        violation: PrivateDependencyViolation;
        privateRealmURLs: string[];
    };
}
export default class PrivateDependencyViolationComponent extends Component<Signature> {
    get hasPrivateRealmDependencies() {
        return this.args.privateRealmURLs.length > 0;
    }
    static{
        template_1aa6f657b4b1439db4b6cd3dd423eaa7(`
    <li
      class='violation'
      data-test-private-dependency-resource={{@violation.resource}}
    >
      <span class='resource'>{{@violation.resource}}</span>
      {{#if this.hasPrivateRealmDependencies}}
        <div class='realm-list'>
          Private
          {{pluralize 'workspace' @privateRealmURLs.length}}:
          {{#each @privateRealmURLs as |realmURL|}}
            <span class='realm' data-test-private-dependency-realm={{realmURL}}>
              {{realmURL}}
            </span>
          {{/each}}
        </div>
      {{/if}}
    </li>

    <style scoped>
      .violation {
        display: flex;
        flex-direction: column;
        gap: var(--boxel-sp-xxxs);
        padding: var(--boxel-sp-xxs) 0;
        font-size: var(--boxel-font-size-sm);
        word-break: break-word;
        overflow-wrap: anywhere;
      }

      .resource {
        font-weight: var(--boxel-font-weight-bold);
      }

      .realm-list {
        display: flex;
        flex-wrap: wrap;
        gap: var(--boxel-sp-xxxs);
      }

      .realm {
        background: var(--boxel-50);
        border-radius: var(--boxel-border-radius-xs);
        color: var(--boxel-550);
        padding: 2px var(--boxel-sp-xxs);
        font-size: var(--boxel-font-size-xs);
        white-space: nowrap;
      }
    </style>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
